var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-checkbox-group',{attrs:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}},_vm._l((_vm.options),function(w,i){return _c('el-checkbox',{key:i,attrs:{"label":w.value}},[_vm._v(_vm._s(w.name))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }